import { Select } from "imagine-ui";
import { DefectStatus, PunchlistText } from "../..";
import { useTranslation } from "react-i18next";

interface Props {
  status?: DefectStatus;
  onChange: (status: DefectStatus) => void;
  className?: string;
  allowNone?: boolean;
}

export const StatusSelect = (props: Props) => {
  const { t } = useTranslation();
  const options = [
    {
      value: DefectStatus.OPEN,
      label: PunchlistText.getDefectStatusText(DefectStatus.OPEN),
    },
    {
      value: DefectStatus.IN_PROGRESS,
      label: PunchlistText.getDefectStatusText(DefectStatus.IN_PROGRESS),
    },
    {
      value: DefectStatus.APPROVED,
      label: PunchlistText.getDefectStatusText(DefectStatus.APPROVED),
    },
    {
      value: DefectStatus.REJECTED,
      label: PunchlistText.getDefectStatusText(DefectStatus.REJECTED),
    },
  ];

  if (props.allowNone) {
    options.unshift({
      value: DefectStatus.NONE,
      label: t("imagine:all"),
    });
  }

  return (
    <Select
      options={options}
      selected={props.status}
      onSelectedNumber={(val) => props.onChange(val as DefectStatus)}
      className={props.className}
    />
  );
};
